import { render, staticRenderFns } from "./LaboratoryServices.vue?vue&type=template&id=afe1e5ec&"
import script from "./LaboratoryServices.vue?vue&type=script&lang=js&"
export * from "./LaboratoryServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports